<template>
	<div class="subscribe-box">
		<div class="content-box">
			<el-button v-if="userTickets&&userTickets.length > 0" @click="getHelpdetailList(99)" style="margin-left: 20px;">Notice/발표</el-button>
			<div class="userinfo-box">
				<el-row type="flex" :gutter="20" class="mb-4">
					<el-col :lg="6" :md="8" :sm="24" :xs="24" class="bold mb-1">
						{{ $t("friends.promotionallinks") }}
					</el-col>
					<el-col :lg="12" :md="8" :sm="24" :xs="24" class="break-all mb-1">
						{{ userprofile.referrallink }}
					</el-col>
					<el-col :lg="4" :md="8" :sm="24" :xs="24">
						<!--            @click="copyLink(userprofile.referrallink)"-->
						<el-button type="primary" size="small" class="table-header-btn"
							v-clipboard:copy="userprofile.referrallink" v-clipboard:success="onCopy"
							v-clipboard:error="onError">{{ $t("friends.copy") }}</el-button>
					</el-col>
				</el-row>
				<el-row type="flex" :gutter="20" class="mb-4">
					<el-col :lg="6" :md="8" :sm="12" :xs="12" class="bold">
						{{ $t("friends.discountcodes") }}
					</el-col>
					<el-col :lg="12" :md="8" :sm="12" :xs="12">
						{{ userprofile.discountcode }}
					</el-col>
				</el-row>
				<el-row type="flex" :gutter="20">
					<el-col :lg="6" :md="6" :sm="12" :xs="12" class="mb-4 bold">
						<span>{{ $t("friends.discountratio") }}</span>
					</el-col>
					<el-col :lg="6" :md="6" :sm="12" :xs="12" class="mb-4">
						<span style="">{{ userprofile?.discode?.discountratio * 100 }}%</span>
					</el-col>
					<el-col :lg="6" :md="6" :sm="12" :xs="12" class="bold">
						<span style="">{{ $t("friends.lowestdiscountratio") }}</span>
					</el-col>
					<el-col :lg="6" :md="6" :sm="12" :xs="12">
						<span style="">{{ userprofile?.discode?.discountratio * 100 }}%</span>
					</el-col>
				</el-row>
			</div>



			<template v-if="userTickets && userTickets.length > 0 || quotaData != null">
				<div class="goods-box" v-for="(item, index) in userTickets" :key="index">
					<div class="goods-card-box" v-if="item.goodsname.toLowerCase().indexOf('chat gpt') !== -1">
						<div @click="getGoodsspuByIdInfo($event, item.goodsid, item.seatno)" class="renew-btn">Renew
						</div>
						<div>
							<div class="header-box">
								<div class="header-left">
									<div class="title">
										Chat GPT4.0
									</div>
								</div>

							</div>
							<div class="conten-box">
								<div class="content-time-box">
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.timeleft") }}</span>
										<span style="color: red">{{ item.ext1 }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.openingtime") }}</span>
										<span style="color: #8e8e8e">{{ item.startTime }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.endtime") }}</span>
										<span style="color: #8e8e8e">{{ item.endTime }}</span>
									</div>
									<!-- account -->
									<!-- <div class="content-time-flex">
                  <span>{{ $t("subscribe.account") }}</span>
                  <span style="color: #8e8e8e">{{ item.loginemail }}</span>
                </div> -->
									<!-- password -->
									<!-- <div class="content-time-flex">
                  <span>{{ $t("subscribe.password") }}</span>
                  <span style="color: #8e8e8e">
                    <el-input
                      type="password"
                      v-model="item.loginpwd"
                      show-password
                    ></el-input>
                  </span>
                </div> -->
									<!-- token -->
									<div class="content-time-flex">
										<span class="bold">Token</span>
										<div class="w-100" style="color: #8e8e8e">
											<passwordInput v-model="item.loginpwd" />
											<!--										<el-input type="password" v-model="item.loginpwd" show-password></el-input>-->
										</div>
									</div>
									<div style="">
										<div style="padding: 10px 0" v-if="!showjoin">
											<el-button type="primary" style="width: 100%" @click="openchat">Open
												GPT</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>






					<div class="goods-card-box" v-else-if="item.goodsname.toLowerCase().indexOf('netflix') !== -1">
						<div @click="getGoodsspuByIdInfo($event, item.goodsid, item.seatno)" class="renew-btn">Renew
						</div>
						<div>
							<div class="header-box">
								<div class="header-left">
									<div class="title">
										{{ item.goodsname }}
									</div>
								</div>
								<!-- <div class="header-right">
              <el-button
                style="background-color: #4a9f9c; border: 0; height: 30px"
                type="primary"
                size="small"
                round
                @click="getGoodsspuByIdInfo(item.goodsSpu.id)"
                >续费</el-button
              >
            </div> -->
							</div>
							<div v-if="item.ext2 == 2">
								<span style="color: red;width: 80%;"> {{ $t("subscribe.subtime")}}⬇️</span>
							  </div>
							<div class="conten-box">
								<div class="content-time-box">
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.timeleft") }}</span>
										<span style="color: red">{{ item.ext2 == 2? '999 Days 99 Hours 99 minute':item.ext1 }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.openingtime") }}</span>
										<span style="color: #8e8e8e">{{ item.startTime }}</span>
									</div>
									<div class="content-time-flex">
										<span  v-if="item.ext2 == 2" class="bold">{{ $t("subscribe.endtime") }}
											<el-tooltip class="item-tips" effect="dark"  placement="top-start">
												<div slot="content">
													<span>
														{{ $t("subscribe.subtimetips")}}
													</span>
												</div>
												<i class="el-icon-question"></i>
										  </el-tooltip>
										</span>
										<span style="color: #8e8e8e">{{ item.ext2 == 2?'9999-99-99 (Previous time:'+item.endTime+')':item.endTime }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.account") }}</span>
										<span style="color: #8e8e8e">{{ item.loginemail }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold" style="color: black">{{
											$t("subscribe.profile")
										}}</span>
										<!--                                        <span style="color: #8E8E8E">사용 해주세요 NO.-->
										<span style="color: #8e8e8e">{{ $t("subscribe.pleaseuse") }}

											<span style="
                    background-color: #5e2d82;
                    padding: 2px 5px;
                    color: white;
                  ">{{ item.seatno + 1 }}</span>
											<!-- sub account</span> -->
											<!--                                            서브 계정</span>-->
											{{ $t("subscribe.subaccount") }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.password") }}</span>
										<div class="w-100" style="color: #8e8e8e">
											<passwordInput v-model="item.loginpwd" />
											<!--										<el-input type="password" v-model="item.loginpwd" show-password></el-input>-->
										</div>
									</div>
									<div class="d-flex">
										<div @click.stop="getlinkoropen(item.loginemail)" style="
                  width: 95%;
                ">
											<div class="psdinput">
												<div>
													<span style="font-weight: bolder">
														{{ $t("subscribe.getverificationlink") }}
														<!-- Get login verification link -->
													</span>
												</div>
												<div style="padding-top: 5px;">
													<span style="
                        font-size: 0.6rem;
                        color: rgb(219 107 107);
                        font-weight: bold;

                      ">
														<!-- If you have not been asked to fill in the verification
                      code,please ignorethis feature. -->
														{{ $t("subscribe.getlinktips") }}
													</span>
												</div>
												<div class="gtlink" @click.stop="getlink(item.loginemail)">
													<!-- {{!showlinkbt?'Click to get link' : 'Already resent ? Get again'}} -->
													{{ !showlinkbt ? $t("subscribe.clickto") : $t("subscribe.Resend") }}
												</div>
												<div v-if="showlinkbt">
													<el-button type="primary" style="width: 100%"
														@click.stop="openurl">get
														Netflix code</el-button>
												</div>
												<div v-if="item.ext2 == 1" style="display: flex;justify-content: center;">
													<el-button
													type="primary"
													style="width: 80%;"
													@click="upAccount(item)"
													>
													<!-- {{ $t("subscribe.submit") }} -->
													Update Netflix Account
													</el-button
												  >
												  </div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="goods-card-box" v-else-if="item.goodsname.toLowerCase().indexOf('youtube') === -1">
						<div @click="getGoodsspuByIdInfo($event, item.goodsid, item.seatno)" class="renew-btn">Renew
						</div>
						<div>
							<div class="header-box">
								<div class="header-left">
									<div class="title">
										{{ item.goodsname }}
									</div>
								</div>
								<!-- <div class="header-right">
                  <el-button
                    style="background-color: #4a9f9c; border: 0; height: 30px"
                    type="primary"
                    size="small"
                    round
                    @click="getGoodsspuByIdInfo(item.goodsSpu.id)"
                    >续费</el-button
                  >
                </div> -->
							</div>
							<div class="conten-box">
								<div class="content-time-box">
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.timeleft") }}</span>
										<span style="color: red">{{ item.ext1 }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.openingtime") }}</span>
										<span style="color: #8e8e8e">{{ item.startTime }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.endtime") }}</span>
										<span style="color: #8e8e8e">{{ item.endTime }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.account") }}</span>
										<span style="color: #8e8e8e">{{ item.loginemail }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold" style="color: black">{{
											$t("subscribe.profile")
										}}</span>
										<!--                                        <span style="color: #8E8E8E">사용 해주세요 NO.-->
										<span style="color: #8e8e8e">{{ $t("subscribe.pleaseuse") }}

											<span style="
                        background-color: #5e2d82;
                        padding: 2px 5px;
                        color: white;
                      ">{{ item.seatno + 1 }}</span>
											<!-- sub account</span> -->
											<!--                                            서브 계정</span>-->
											{{ $t("subscribe.subaccount") }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.password") }}</span>
										<div class="w-100" style="color: #8e8e8e">
											<passwordInput v-model="item.loginpwd" />
											<!--										<el-input type="password" v-model="item.loginpwd" show-password></el-input>-->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="goods-card-box" v-if="item.goodsname.toLowerCase().indexOf('youtube') !== -1">
						<div @click="getGoodsspuByIdInfo($event, item.goodsid, item.seatno)" class="renew-btn">Renew
						</div>
						<div>
							<div @click="toytbPage(item)" class="toytb-btn">
								<span class="toytb-btn-text">YouTube를 갑자기 이용할 수 없게 됐나요?</span>
							</div>
							<div class="header-box">
								<div class="header-left">
									<div class="title">
										{{ item.goodsname }}
									</div>
								</div>
								<!-- <div class="header-right">
                  <el-button
                    style="background-color: #4a9f9c; border: 0; height: 30px"
                    type="primary"
                    size="small"
                    round
                    @click="getGoodsspuByIdInfo(item.goodsSpu)"
                    >Renewal</el-button
                  >
                </div> -->
							</div>
							<div class="conten-box">
								<div class="content-time-box">
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.timeleft") }}</span>
										<span style="color: red">{{ item.ext1 }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.openingtime") }}</span>
										<span style="color: #8e8e8e">{{ item.startTime }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.endtime") }}</span>
										<span style="color: #8e8e8e">{{ item.endTime }}</span>
									</div>
									<div class="break-word">
										가입 시 "Not in a country" 팝업이 표시되는 경우
										<a
											href="https://pay.google.com/gp/w/u/0/home/settings">https://pay.google.com/gp/w/u/0/home/settings</a>
										설정에서 모든 청구 주소를 삭제하려면 이 URL로 이동하세요 .
										그런 다음 등록할 수 있습니다.<br />
										{{ $t("subscribe.youtubeloginemail") }}
									</div>
									<div class="content-time-flex youtube">
										<el-form :model="form" :rules="rules" ref="ruleForm" v-if="!showjoin">
											<el-form-item prop="email" style="width: 100%">
												<el-input v-model="form.email"
													placeholder="YouTube login email"></el-input>
											</el-form-item>
											<!-- <el-form-item prop="password">
                        <el-input
                          v-model="form.password"
                          placeholder="YouTube login password"
                        ></el-input>
                      </el-form-item> -->
											<!-- <el-button type="primary" style="width: 100%" @click="submitUser(item.id)">submit</el-button> -->
											<el-button type="primary" style="width: 100%"
												@click="submitUser(item.id, item.loginemail)">{{ $t("subscribe.submit")
												}}</el-button>
										</el-form>
										<div class="joinyoutube" v-if="showjoin">
											<div style="
                    margin: 10px 0;
                    display: flex;
                    justify-content: space-between;
                  ">
												<span style="color: #8e8e8e; width: 75%">
													<el-input style="flex: 1" v-model="item.loginemail"
														id="copyText"></el-input>
												</span>
												<el-button @click="copy">copy</el-button>
											</div>
											<div style="margin: 10px 0">
												<el-button type="primary" style="width: 100%"
													@click="joinyoutube(item.loginemail)">Join</el-button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="goods-box" v-if="quotaData != null">
					<div class="goods-card-box">
						<div>
							<div class="header-box">
								<div class="header-left">
									<div class="title">
										Share AI
									</div>
								</div>

							</div>
							<div class="conten-box">
								<div class="content-time-box">
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.openingtime") }}</span>
										<span style="color: #8e8e8e">{{ quotaData.startDate }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.endtime") }}</span>
										<span style="color: #8e8e8e">{{ quotaData.endDate }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.nextresetdate") }}</span>
										<span style="color: #8e8e8e">{{ quotaData.nextResetDate }}</span>
									</div>
									<div class="content-time-flex">
										<span class="bold">{{ $t("subscribe.paidquota") }}</span>
										<span style="color: #8e8e8e">{{ quotaData.paidQuota }}</span>
									</div>
									<div style="">
										<div style="padding: 10px 0" v-if="!showjoin">
											<el-button type="primary" style="width: 100%" @click="gochat">Share
												AI</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>




		<!-- 支付详情 -->
		<van-popup v-model="show" position="bottom" :style="{ height: '72%', width: '90%' }" class="popup-details">
			<div class="details-header-box">
				<van-image radius="8" width="6rem" height="6rem" :src="spu.img" />
				<div style="margin-left: 5%">
					<div style="margin-top: 10px">
						<span style="color: #43d98e; font-weight: bolder; font-size: 1.8em">${{ price }}</span>
						<del style=" color: red;font-weight: bolder;font-size: 1em;margin-left: 10px;"
							v-if="'' != originalprice && originalprice > price">${{ originalprice }}</del>
					</div>
					<div style="font-size: 1em; color: #969799">
						<span>{{ form1.num }} {{ $t("home.parkingspace") }}</span>
						<span style="margin-left: 10px">{{ month }}</span>
					</div>
					<div style="font-size: 1em; font-weight: bolder; color: red">
						<span v-if="giftstimes > 0">
							{{ $t("home.gift") }} {{ giftstimes }} month</span>
					</div>
				</div>
			</div>
			<el-divider style="background-color: #e9ebec" />
			<div class="details-content-box">
				<el-form :model="form1" :rules="rules1" ref="ruleForm1">
					<div style="color: #000">
						<p>{{ $t("home.month") }}</p>
					</div>
					<el-form-item style="margin-bottom: 1rem" prop="skuid">
						<el-radio-group v-model="form1.skuid" style="display: flex; flex-wrap: wrap" size="mini"
							@change="updatePrice">
							<el-radio-button :label="item.id" v-for="(item, index) in skuFilterList" :key="index"
								class="skuname" style="margin-right: 0.5rem">{{ item.skuname }}</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<div style="color: #000">
						<p>{{ $t("home.screen") }}</p>
					</div>
					<el-form-item style="margin-bottom: 1rem" prop="num">
						<!-- 						<el-radio-group v-model="form1.num" size="mini" style="display: flex" v-if="spu.type == '3'"
							@change="updateSku">
							<el-radio-button label="1" class="skuname">{{$t("home.1screen")}}</el-radio-button>
							<el-radio-button label="2" class="skuname" v-if="spu.maxnum > 1">{{ spu.maxnum }}
								{{ $t("home.maxnum") }}</el-radio-button>
						</el-radio-group> -->
						<el-radio-group v-model="form1.num" size="mini" style="display: flex" v-if="spu.num > 1"
							@change="updateSku">

							<el-radio-button label="2" class="skuname">{{ spu.maxnum }}
								{{ $t("home.maxnum") }}</el-radio-button>
						</el-radio-group>
						<el-radio-group v-model="form1.num" size="mini" style="display: flex" v-else
							@change="updateSku">
							<el-radio-button label="1" class="skuname">{{ $t("home.1screen") }}</el-radio-button>
						</el-radio-group>
					</el-form-item>

					<div style="color: #000">
						<p>{{ $t("home.buytyp") }}</p>
					</div>
					<el-form-item style="margin-bottom: 1rem" prop="buytype">
						<el-radio-group size="mini" v-model="form1.buytype" style="display: flex">
							<el-radio-button label="1" class="skuname">{{ $t("home.subscription") }}</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<div>
						<span style="color: #000">{{ $t("home.discountcode") }}</span>
						<div style="display: flex">
							<el-input type="text" v-model="form1.discountcode" :placeholder="$t('home.discountcode')"
								style="flex: 1" clearable size="small"></el-input>
							<el-button size="small" type="primary" style="margin-left: 3%" @click="useDiscountcode">{{
								$t("home.use") }}</el-button>
						</div>
					</div>
					<el-form-item style="margin-bottom: 1rem" prop="paycode">
						<span style="color: #000">{{ $t("home.paymentmethod") }}</span>
						<div>
							<el-select style="width: 82%" v-model="form1.paycode" :placeholder="$t('home.pleasechoose')"
								size="small">
								<el-option v-for="item in payOptions" :key="item.code" :label="item.name"
									:value="item.code">
								</el-option>
							</el-select>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="details-footer-box">
				<el-button style="width: 100%" type="primary" round @click="soonbug">{{ $t("home.buynow") }}</el-button>
			</div>
		</van-popup>



		<!-- payss -->
		<van-popup v-model="showpayssion" position="bottom" :style="{ height: '72%', width: '90%' }"
			class="popup-details">
			<div class="darwer-box">
				<el-descriptions class="content-title" :column="1">
					<el-descriptions-item class="content-item" label="tips">{{ $t('home.buytips')
					}}</el-descriptions-item>
					<el-descriptions-item class="content-item" label="Product Name">{{ goodsname
						}}</el-descriptions-item>
					<el-descriptions-item class="content-item" label="Price">{{ price }} USD</el-descriptions-item>
					<el-descriptions-item class="content-item" label="month" :span="2">{{ month
						}}</el-descriptions-item>
				</el-descriptions>
				<el-form :model="form2" :rules="rules2" ref="ruleForm2" label-position="top" size="medium">
					<el-form-item :label="$t('home.phone')" prop="phone">
						<el-input v-model="form2.phone"></el-input>
					</el-form-item>
				</el-form>
				<el-button style="width: 100%" type="primary" round @click="topayment">{{ $t("home.buynow")
				}}</el-button>
			</div>
		</van-popup>

		<toBuy ref="toBuyRef" @goPay="goPay" :form1Obj="form1" :skuFilterList="skuFilterList" />
		<goPay ref="goPayRef" @closeToBuy="closeToBuy" @openBillDetails="openBillDetails" :form1Obj="form1"
			:goodsname="goodsname" :discountCodeFlag="discountCodeFlag" pageName="psubscribe" />
		<billingDetails ref="billingDetails" :form1Obj="form1" />
		<toytb ref="toytbRef" :form1Obj="form1" />
		<noticeModal ref="noticeModal"/>
	</div>
</template>
<script>
import {
	userAllTicket,
	getGoodsspuById,
	orderRenew,
	calprice,
	carinforesetpwd,
	carinforeminder,
	paytypeall,
	payssion,
	stripe,
	insertWorkorder,
	logoutToken,
	getUserByid,
	insertWithdrawal,
	getnfcodelink,
	getUserActiveSubscription,
	updateUticket,
	getHelpdetailByid
} from "@/request/requests";
import {
	getUserInfo,
	formatObj,
	isEmpty,
	MessageError,
	MessageInfo,
	MessageSuccess,
	startLoading,
	nfstartLoading,
	aminuteLoading,
} from "@/util/util";
// import { Icon } from 'ant-design-vue';

// const IconFont = Icon.createFromIconfontCN({
//     scriptUrl: 'https://at.alicdn.com/t/c/font_3778069_0whrgs2ck2jr.js',
// });
import toBuy from "./phome/toBuy";
import goPay from "./phome/goPay";
import passwordInput from "../../components/passwordInput";
import billingDetails from "./phome/billingDetails";
import toytb from "../ytb/ptoytb";
import noticeModal from "./noticeModal.vue";
export default {
	components: {
		// IconFont,
		toBuy,
		goPay,
		passwordInput,
		billingDetails,
		toytb,
		noticeModal
	},
	name: "psubscribe",
	data() {
		let validateNumber = (rule, value, callback) => {
			if (!/^[0-9]*$/.test(value)) {
				callback(new Error("CVV ERROR!"));
			} else {
				callback();
			}
		};
		return {
			quotaData: null,
			spu: '',
			goodsname: '',
			payOptions: [],
			skuFilterList: [],
			form1: {
				goodsid: "",
				skuid: "",
				num: "",
				buytype: "",
				paycode: "",
				discountcode: "",
			},
			priceObj: {
				price: 0,
				month: '',
				giftstimes: 0,
			},
			show: false,
			seatno: '',
			showpayssion: false,
			codelink: '',
			showlinkbt: false,
			showjoin: false,
			temp: "",
			userinfo: "",
			userTickets: [],
			drawer1: false,
			drawer3: false,
			drawer4: false,
			payReslutIcon: "https://kilogod.oss-cn-shenzhen.aliyuncs.com/alongshare/paysuccess.png",
			// payReslutTitle:"Payment succeeded",
			payReslutTitle: "결제 성공",
			price: "",
			originalprice: "",
			month: "",
			giftstimes: "",
			form: this.initform(),
			rules: {
				email: [{
					required: true,
					message: "Please enter the Email",
					trigger: "blur",
				},],
				password: [{
					required: true,
					message: "Please enter the Email",
					trigger: "blur",
				},],
			},
			tableConfig1: {
				url: "",
				dataPath: "data.list",
				totalPath: "data.total",
				paginationSize: 10,
				extraButtons: [],
				headerButtons: [],
				hasDelete: false,
				hasEdit: false,
				hasOperation: false,
				hasNew: false,
				operationAttrs: {
					width: "100px",
					fixed: "right",
				},
			},
			// 用户信息
			userprofile: {},
			form2: this.initform2(),
			rules2: {
				firstname: [
					// { required: true, message: 'please enter first name', trigger: 'blur' },],
					// { required: true, message: '이름을 입력하세요', trigger: 'blur' },],
					{
						required: true,
						message: this.$t("home.pleaseenter") + " " + this.$t("home.firstname"),
						trigger: "blur",
					},
				],
				lastname: [
					// { required: true, message: 'please enter lastname', trigger: 'blur' },],
					// { required: true, message: '성을 입력하세요.', trigger: 'blur' },],
					{
						required: true,
						message: this.$t("home.pleaseenter") + " " + this.$t("home.lastname"),
						trigger: "blur",
					},
				],
				company: [{
					required: true,
					message: "please enter company",
					trigger: "blur"
				},],
				// { required: true, message: '회사를 입력하십시오', trigger: 'blur' },],
				country: [
					// { required: true, message: 'please enter country', trigger: 'blur' },],
					// { required: true, message: '국가를 입력하십시오', trigger: 'blur' },],
					{
						required: true,
						message: this.$t("home.pleaseenter") + " " + this.$t("home.country"),
						trigger: "blur",
					},
				],
				state: [
					// { required: true, message: 'please enter state', trigger: 'blur' },],
					// { required: true, message: '국가/주', trigger: 'blur' },],
					{
						required: true,
						message: this.$t("home.pleaseenter") + " " + this.$t("home.state"),
						trigger: "blur",
					},
				],
				city: [
					// { required: true, message: 'please enter city', trigger: 'blur' },],
					// { required: true, message: '도시를 입력하십시오', trigger: 'blur' },],
					{
						required: true,
						message: this.$t("home.pleaseenter") + " " + this.$t("home.city"),
						trigger: "blur",
					},
				],
				address: [
					// { required: true, message: 'please enter address', trigger: 'blur' },],
					// { required: true, message: '주소를 입력하십시오', trigger: 'blur' },],
					{
						required: true,
						message: this.$t("home.pleaseenter") + " " + this.$t("home.address"),
						trigger: "blur",
					},
				],
				postalcode: [
					// { required: true, message: 'please enter postal code', trigger: 'blur' },],
					// { required: true, message: '우편번호를 입력하세요', trigger: 'blur' },],
					{
						required: true,
						message: this.$t("home.pleaseenter") + " " + this.$t("home.zipcode"),
						trigger: "blur",
					},
				],
				phone: [
					// { required: true, message: 'please enter phone', trigger: 'blur' },
					// { required: true, message: '전화를 입력하십시오', trigger: 'blur' },
					{
						required: true,
						message: this.$t("home.pleaseenter") + " " + this.$t("home.phone"),
						trigger: "blur",
					},
				]
			},
			rules1: {
				// skuid :[
				//     {required: true, message: 'Please select a month', trigger: 'blur'},],
				// num :[
				//     {required: true, message: 'Please select the number of screens', trigger: 'blur'},],
				// buytype :[
				//     {required: true, message: 'Please select the purchase type', trigger: 'blur'},],
				// paycode :[
				//     {required: true, message: 'Please select the payment method', trigger: 'blur'},],
				skuid: [
					// { required: true, message: 'Please select a month', trigger: 'blur' },],
					{
						required: true,
						message: "월을 선택하세요.",
						trigger: "blur"
					},
				],
				num: [
					// { required: true, message: 'Please select the number of screens', trigger: 'blur' },],
					{
						required: true,
						message: "하위 계정 수를 선택하세요.",
						trigger: "blur",
					},
				],
				buytype: [
					// { required: true, message: 'Please select the purchase type', trigger: 'blur' },],
					{
						required: true,
						message: "구매유형을 선택해주세요",
						trigger: "blur",
					},
				],
				paycode: [
					// { required: true, message: 'Please select the payment method', trigger: 'blur' },],
					{
						required: true,
						message: "결제수단을 선택해주세요",
						trigger: "blur",
					},
				],
			},
			form3: this.initform3(),
			rules3: {
				name: [
					// { required: true, message: 'Please enter Name on card', trigger: 'blur' },],
					{
						required: true,
						message: "카드 소유자 이름을 입력하십시오",
						trigger: "blur",
					},
				],
				cardnumber: [
					// { required: true, message: 'Please enter Card number', trigger: 'blur' },],
					{
						required: true,
						message: "카드번호를 입력해주세요",
						trigger: "blur",
					},
				],
				cvv: [{
					required: true,
					message: "Please enter CVV",
					trigger: "blur"
				},
				{
					validator: validateNumber,
					trigger: "blur"
				},
				],
				date: [
					// { required: true, message: 'Please enter Expiry date', trigger: 'blur' },],
					{
						required: true,
						message: "만료 날짜를 입력하세요.",
						trigger: "blur",
					},
				],
			},
			discountCodeFlag: false,
			upAccountTime:"",
		};
	},
	methods: {
		isEmpty,
		// 油管选择页面
		toytbPage(item) {
			this.$refs['toytbRef'].init(item)
		},
		openBillDetails() {
			this.$refs['billingDetails'].init();
		},
		closeToBuy() {
			this.$nextTick(() => {
				this.$refs['toBuyRef'].closeDialog();
			})
		},
		onCopy(e) {
			MessageSuccess(this.$t('friends.copysuccessfully'));
			console.log('copy Success:' + e.text);
		},
		onError(e) {
			MessageError(this.$t('friends.copyfailed'));
			console.log('copy Failed:' + e.text);
		},
		updateSku(val) {
			this.skuFilterList = []
			let i = 0
			this.spu.skus.forEach((r) => {
				if (r.type == val) {
					let obj = {
						id: r.id,
						goodsid: r.goodsid,
						skuname: r.skuname,
						price: r.price,
						giftstimes: r.giftstimes,
					};
					this.skuFilterList.push(obj);
					if (i == 0) {
						this.form1.skuid = r.id;
						this.priceObj.price = r.price;
						this.priceObj.month = r.skuname;
						this.priceObj.giftstimes = r.giftstimes;
					}
					i++;
				}
			});
		},
		async getGoodsspuByIdInfo(event, id, seatno) {
			let targetEvent = event.target.tagName.toLowerCase();
			console.log(targetEvent);
			if (targetEvent === 'input') {
				return
			}
			let loading = startLoading();
			let res = await getGoodsspuById(id);
			if (res.status == "200") {
				this.seatno = seatno;
				this.spu = res.data;
				this.goodsname = this.spu.goodsname;
				this.form1 = {
					goodsid: this.spu.id,
					skuid: this.spu.skus[0].id,
					num: 1,
					buytype: "1",
					paycode: this.payOptions[0].value,
					discountcode: ""
				};
				this.$nextTick(() => {
					this.$refs['toBuyRef'].init(formatObj(this.spu))
				})
				loading.close();
			} else {
				MessageError(res.msg);
				loading.close();
			}
		},
		/**
		 * @param priceObj 价格对象
		 * @param form1
		 * @param discountCodeFlag 折扣码是否已经生效 true/false
		 */
		goPay(priceObj, form1, discountCodeFlag) {
			this.discountCodeFlag = discountCodeFlag;
			this.form1 = form1;
			this.$nextTick(() => {
				this.$refs['goPayRef'].init(priceObj);
			})
		},
		topayment() {
			//   this.tostripe()
			if ("stripe" == this.form1.paycode) {
				this.tostripe()
			} else {
				this.topayssion()
			}
		},
		async tostripe() {
			let session_id = sessionStorage.getItem("session_id");
			const params = {
				pmid: "alipay_cn",
				amount: 0.07,
				description: this.goodsname + this.price + this.month,
				goodsid: this.form1.goodsid,
				skuid: this.form1.skuid,
				num: this.form1.num,
				buytype: this.form1.buytype,
				paycode: this.form1.paycode,
				// paycode: "payssion_test",
				discountcode: this.form1.discountcode,

				firstname: this.form2.firstname,
				lastname: this.form2.lastname,
				company: this.form2.company,
				country: this.form2.country,
				state: this.form2.state,
				city: this.form2.city,
				address: this.form2.address,
				postalcode: this.form2.postalcode,
				phone: this.form2.phone,
				email: this.form2.email,

				name: this.form3.name,
				cardnumber: this.form3.cardnumber,
				cvv: this.form3.cvv,
				date: this.form3.date,
				issave: this.form3.issave == true ? 1 : 0,
				userid: this.userinfo.id,
				sessionid: session_id,
			};
			const res = await stripe(params);
			let loading = startLoading();
			if (res.status == 200) {
				window.open(res.data, "_self");
			} else {
				loading.close();
				MessageError(res.msg);
			}
		},
		// payssion 购买
		async topayssion() {
			let session_id = sessionStorage.getItem("session_id");
			const params = {
				pmid: "alipay_cn",
				amount: 0.07,
				description: this.goodsname + this.price + this.month,
				goodsid: this.form1.goodsid,
				skuid: this.form1.skuid,
				num: this.form1.num,
				buytype: this.form1.buytype,
				paycode: this.form1.paycode,
				// paycode: "payssion_test",
				discountcode: this.form1.discountcode,

				firstname: this.form2.firstname,
				lastname: this.form2.lastname,
				company: this.form2.company,
				country: this.form2.country,
				state: this.form2.state,
				city: this.form2.city,
				address: this.form2.address,
				postalcode: this.form2.postalcode,
				phone: this.form2.phone,
				email: this.form2.email,

				name: this.form3.name,
				cardnumber: this.form3.cardnumber,
				cvv: this.form3.cvv,
				date: this.form3.date,
				issave: this.form3.issave == true ? 1 : 0,

				userid: this.userinfo.id,
				sessionid: session_id,
			};
			const res = await payssion(params);
			let loading = startLoading();
			if (res.status == 200) {
				window.open(res.data.redirect_url, "_self");
			} else {
				loading.close();
				MessageError(res.msg);
			}
		},
		openurl(url) {
			url = this.codelink
			window.open(url, "target");
		},
		joinyoutube(url) {
			window.open(url, "target");
		},
		copy() {
			let copyCon = document.getElementById("copyText");
			copyCon.select(); // 选中文本
			document.execCommand("copy"); // 执行浏览器复制命令
			this.$message.success("copy!");
		},
		// 获取折扣信息
		async getUserByidInfo() {
			let res = await getUserByid(this.userinfo.id);
			if (res.status == "200") {
				this.userprofile = res.data;
				this.userprofile.referrallink =
					"https://www.alongshare.com/?usercode=" + res.data.referrallink;
			} else {
				MessageError(res.msg);
			}
		},
		async operatorUser1() {
			this.form.userid = this.userprofile.id;
			let res = await insertWithdrawal(this.form);
			if (res.status == "200") {
				MessageSuccess(res.msg);
				this.getUserByidInfo();
				this.closeDialog();
			} else {
				MessageError(res.msg);
			}
		},
		handleTab1() {
			this.getUserByidInfo()
			this.tableConfig1.axiosConfig = {
				headers: {
					Authorization: "X-KILOGOD-AUTHORIZATION " + this.$cookies.get("token"),
				},
			};
			this.tableConfig1.url =
				"commission/getUserById?reuserid=" + this.userinfo.id;
		},
		openchat() {
			// window.open('http://www.alongshare.top:8001/list','target')
			window.open("https://www.gosharegpt.com/list", "target");
		},
		gochat() {
			this.$router.push({ path: "/shareAI" });
		},
		// 获取用户ai订阅信息
		async getUserActiveSubscription() {
			let res = await getUserActiveSubscription();
			if (res.status == '200') {
				let data = res.data;
				if (!this.isEmpty(data)) {
					this.quotaData = data;
					this.quotaData.nextResetDate = this.$moment(this.quotaData.nextResetDate).format('yyyy-MM-DD');
				}
			}
		},
		// 提交用户
		async submitUser(ticketid, loginemail) {
			if ("" != this.form.email.trim() && null != this.form.email) {
				// this.$alert(this.$t("subscribe.submitYoutube")), '', {
				//   confirmButtonText: 'Confirm',
				// }
				// this.operatorUser(ticketid);
				// this.showjoin = true
				this.operatorUser(ticketid);
				window.open(loginemail, "target");
			} else {
				MessageError("Please enter the Email");
				return;
			}
		},
		async operatorUser(ticketid) {
			this.form.userid = this.userinfo.id;
			this.form.ticketid = ticketid;
			// this.form.typeid = 5;
			this.form.typeid = 8;
			// this.form.content = "email:" + this.form.email + `\n` + "pwd:" + this.password;
			this.form.content = "Complete email:" + this.form.email;
			let res = await insertWorkorder(this.form);
			if (res.status == "200") {
				// MessageSuccess("처리 상태가 제출되었습니다. 작업 주문서에서 처리 상태를 확인하십시오.")
				// MessageSuccess(
				//   "처리 상태가 제출되었습니다. 작업 주문서에서 처리 상태를 확인하십시오."
				// );
				this.form = this.initform();
				this.$refs.ruleForm.clearValidate();
			} else {
				MessageError(res.msg);
			}
		},
		initform() {
			return {
				id: "", // 序号
				userid: "", // 用户id
				workorderno: "", // 工单号
				ticketid: "", // 车票id
				typeid: "", // 类型id
				content: "", // 工单内容
				status: "", // 状态
				reply: "", // 处理回复
				password: "",
				email: "",
			};
		},
		initform1() {
			return {
				goodsid: "",
				skuid: "",
				num: "",
				buytype: "",
				paycode: "",
				discountcode: "",
			};
		},



		initform2() {
			return {
				firstname: "",
				lastname: "",
				company: "",
				country: "",
				state: "",
				city: "",
				address: "",
				address1: "",
				postalcode: "",
				phone: "",
				email: "",
			};
		},


		initform3() {
			return {
				name: "",
				cardnumber: "",
				cvv: "",
				date: "",
				issave: "",
			};
		},
		playorder() {
			this.$refs.ruleForm3.validate((valid) => {
				if (valid) {
					let userInfo = getUserInfo();
					if (userInfo) {
						this.userinfo = JSON.parse(userInfo);
						this.toSubmitOrder();
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		async toSubmitOrder() {
			let session_id = this.$cookies.get("session_id");
			let data = {
				goodsid: this.form1.goodsid,
				skuid: this.form1.skuid,
				num: this.form1.num,
				buytype: this.form1.buytype,
				paycode: this.form1.paycode,
				discountcode: this.form1.discountcode,

				name: this.form3.name,
				cardnumber: this.form3.cardnumber,
				cvv: this.form3.cvv,
				date: this.form3.date,
				issave: this.form3.issave == true ? 1 : 0,

				userid: this.userinfo.id,
				sessionid: session_id,
			};
			let loading = aminuteLoading();
			let res = await orderRenew(data);
			if (res.status == "200") {
				this.closeAllDrawer();
				loading.close();
				this.drawer4 = true;
				this.payReslutIcon =
					"https://kilogod.oss-cn-shenzhen.aliyuncs.com/alongshare/paysuccess.png";
				// this.payReslutTitle="Payment succeeded"
				this.payReslutTitle = "결제 성공";
			} else {
				loading.close();
				this.drawer4 = true;
				this.payReslutIcon =
					"https://kilogod.oss-cn-shenzhen.aliyuncs.com/alongshare/payerror.png";
				this.payReslutTitle = res.msg;
			}
			loading.close();
		},
		closeAllDrawer() {
			this.drawer1 = false;
			this.drawer3 = false;
			this.form1 = this.initform1();
			this.form3 = this.initform3();
			this.userAllTicketInfo();
		},
		updatePrice() {
			this.spu.skus.forEach((r) => {
				if (r.id == this.form1.skuid) {
					this.price = this.form1.num * r.price;
					this.originalprice = "";
					this.month = r.skuname;
					this.giftstimes = r.giftstimes;
				}
			});
		},
		async useDiscountcode() {
			let code = this.form1.discountcode.trim();
			if ("" == code || null == code) {
				// MessageError("Discount code cannot be empty!")
				MessageError("할인 코드는 비워둘 수 없습니다!");

				return;
			}
			let userInfo = getUserInfo();
			if (userInfo) {
				this.userinfo = JSON.parse(userInfo);
				let data = {
					goodsid: this.form1.goodsid,
					skuid: this.form1.skuid,
					num: this.form1.num * 1,
					discountcode: this.form1.discountcode,
					userid: this.userinfo.id,
				};
				let loading = startLoading();
				let res = await calprice(data);
				if (res.status == "200") {
					if (0 != res.data && res.data < this.price) {
						this.originalprice = this.price;
						this.price = res.data;
					}
					loading.close();
				} else {
					MessageError(res.msg);
					loading.close();
				}
				loading.close();
			}
		},
		async soonbug() {
			this.$refs.ruleForm1.validate((valid) => {
				if (valid) {
					let userInfo = getUserInfo();
					if (userInfo) {
						this.userinfo = JSON.parse(userInfo);
						//this.drawer3 = true;
						this.showpayssion = true;
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		async userAllTicketInfo() {
			let loading = startLoading();
			let res = await userAllTicket(this.userinfo.id);
			if (res.status == "200") {
				this.userTickets = res.data;
				// 显示公告
				this.getHelpdetailList();
				// gpt密码处理
				for (let i = 0; i < this.userTickets.length; i++) {
					if (this.userTickets[i].goodsid == 8) {
						let seatno = this.userTickets[i].seatno + 1
						if (this.userTickets[i].seatno % 2 == 0) {
							console.log("TCL: userAllTicketInfo -> kk", seatno)
							this.userTickets[i].loginpwd = this.userTickets[i].loginpwd + seatno
						} else {
							this.userTickets[i].loginpwd = seatno + this.userTickets[i].loginpwd
						}
					}
				}
				if (res.data.length > 0) {
					this.userTickets.forEach((r) => {
						r.ext1 = this.countTime(r.endTime);
					});
					this.temp = setInterval(() => {
						this.userTickets.forEach((r) => {
							r.ext1 = this.countTime(r.endTime);
						});
					}, 60000);
				}
				loading.close();
			} else {
				MessageError(res.msg);
				loading.close();
			}
			loading.close();
		},
		countTime(time) {
			//获取当前时间
			let date = new Date();
			let now = date.getTime();
			//设置截止时间
			let endDate = new Date(time);
			let end = endDate.getTime();
			//时间差
			let leftTime = end - now;
			//定义变量 d,h,m,s保存倒计时的时间
			let count;
			if (leftTime >= 0) {
				let d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
				d = d < 10 ? "0" + d : d;
				let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
				h = h < 10 ? "0" + h : h;
				let m = Math.floor((leftTime / 1000 / 60) % 60);
				m = m < 10 ? "0" + m : m;
				// let s = Math.floor(leftTime / 1000 % 60);
				// s = s < 10 ? "0" + s : s
				// count = d + ' Days ' + h + ' Hours ' + m + ' minute ' + s + ' second'
				count = d + " Days " + h + " Hours " + m + " minute ";
			}
			// console.log(count);
			return count;
		},
		// 拉起详情
		tobuy(spu) {
			this.spu = spu;
			this.goodsname = this.spu.goodsname;
			this.show = !this.show;
			this.form1 = {
				goodsid: spu.id,
				skuid: spu.skus[0].id,
				num: 1,
				buytype: "1",
				paycode: this.payOptions[0].value,
				discountcode: "",
			};
			// this.price = spu.skus[0].price;
			// this.month = spu.skus[0].skuname;
			// this.giftstimes = spu.skus[0].giftstimes;

			if (spu.type == '3' || spu.type == '1') {
				this.updateSku('1');
			} else {
				this.updateSku('2');
			}


		},
		resetpwd(val) {
			// this.$confirmel('The original password for this operation will no longer be used, whether to continue?', 'Tips', {
			this.$confirmel(
				"이 작업의 원래 암호는 더 이상 사용되지 않습니다. 계속하시겠습니까?",
				"팁", {
				// confirmButtonText: 'Confirm',
				confirmButtonText: "확인",
				// cancelButtonText: 'Cancel',
				cancelButtonText: "취소",

				type: "warning",
			}
			)
				.then(() => {
					this.toResetpwd(val);
				})
				.catch(() => {
					// MessageInfo("Canceled");
					MessageInfo("취소");
				});
		},
		async toResetpwd(val) {
			let data = {
				carid: val.carid,
			};
			let loading = startLoading();
			let res = await carinforesetpwd(data);
			if (res.status == "200") {
				MessageSuccess(res.msg);
				this.userAllTicketInfo();
				loading.close();
			} else {
				MessageError(res.msg);
				loading.close();
			}
			loading.close();
		},
		async toResetpwd1(val) {
			if (
				!
				/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/
					.test(
						val.loginpwd
					)
			) {
				// MessageError('The password meets uppercase and lowercase letters, numbers and special characters, any combination of three of them, and the length is between 8 and 16!');
				MessageError(
					"비밀번호는 대문자와 소문자, 숫자, 특수문자 중 3가지 조합을 모두 충족하며, 길이는 8자에서 16자 사이!"
				);

				return;
			} else {
				let data = {
					carid: val.carid,
					loginpwd: val.loginpwd,
				};
				let loading = startLoading();
				let res = await carinforesetpwd(data);
				if (res.status == "200") {
					MessageSuccess(res.msg);
					this.userAllTicketInfo();
					loading.close();
				} else {
					MessageError(res.msg);
					loading.close();
				}
				loading.close();
			}
		},
		async remind(val) {
			let loading = startLoading();
			let res = await carinforeminder(val.carid);
			if (res.status == "200") {
				MessageSuccess(res.msg);
				loading.close();
			} else {
				MessageError(res.msg);
				loading.close();
			}
			loading.close();
		},
		async paytypeallInfo() {
			let res = await paytypeall();
			if (res.status == "200") {
				this.payOptions = res.data;
			} else {
				MessageError(res.msg);
			}
		},
		// 退出登陆
		lognout() {
			// this.$confirmel('Are you sure you want to log out?', 'Tips', {
			this.$confirmel("로그아웃하시겠습니까??", "팁", {
				// confirmButtonText: 'comfirm',
				confirmButtonText: "확인",
				// cancelButtonText: 'cancel',
				cancelButtonText: "취소",
				type: "warning",
			})
				.then(() => {
					this.logout();
				})
				.catch(() => { });
		},
		async logout() {
			sessionStorage.removeItem("userInfo");
			sessionStorage.removeItem("deadline");
			await logoutToken();
			sessionStorage.removeItem("token");
			// this.$router.push({ path: "login" })
			if ("ontouchstart" in document.documentElement) {
				this.$router.push({
					path: "/phonehome"
				});
			} else {
				return this.$router.push({
					path: "login"
				});
			}
		},
		getlinkoropen(email) {
			this.codelink = 1;
			if (!this.codelink) {
				this.getlink(email)
			} else {
				this.openurl()
			}
		},
		async getlink(email) {
			let loading = nfstartLoading();
			let res = await getnfcodelink(email);
			if (res.code == "200") {
				const link = res.result.link
				if (link) {
					this.codelink = link
					this.showlinkbt = true;
					loading.close();
					this.openurl(link)
				} else {
					MessageError("No code, please try again");
					this.showlinkbt = false
					alert('No code, Please resend the code')
					loading.close();
				}
			} else {
				MessageError("netflix Code Error");
			}
			loading.close();
		},
		upAccount(row){
      if(!isEmpty(this.upAccountTime)){
        clearTimeout(this.upAccountTime);
      }
      this.upAccountTime = setTimeout(()=>{
        updateUticket(row).then(res=>{
          if (res.status == "200") {
            MessageSuccess(res.msg)
          } else {
            MessageError("There is no stock at present. Please wait patiently.");
          }
          this.$router.go(0);
        })

      },5000)
    },
    async getHelpdetailList(flag){
      let res = await getHelpdetailByid("13");
      if(res.status == "200"){
        if(flag==99){
          this.$refs['noticeModal'].init(formatObj(this.tableList[0]),99);
        }else{
          this.tableList = res.data.list;
          this.$refs['noticeModal'].init(formatObj(this.tableList[0]),this.userTickets.length);
        }
      }
    }
	},
	mounted() {
		let userInfo = getUserInfo();
		if (userInfo) {
			this.userinfo = JSON.parse(userInfo);
			this.userAllTicketInfo();
			this.paytypeallInfo();
			this.handleTab1();
			this.getUserActiveSubscription();
		}
	},
	destroyed() {
		clearInterval(this.temp);
		// console.log(this.temp,"销毁")
	},
};
</script>

<style lang="scss" scoped>
.subscribe-box {
	font-family: SourceHanSansCN-Regular;

	//color: #fff;
	//background-color: rgb(35, 39, 44);
	//background-color: #F0FFF0;
	// height: 100vh;
	.title {
		margin-bottom: 20px;
	}

	/*  */
	.ant-layout-content {
		flex: none;
		min-height: 60vh;
	}

	.content-box {
		//min-height:60vh;
		//padding: 20px;
		//background-color: #22272d;
		//background-color: #F0FFF0;

		/* background-color: var(--gray-050); */
		/* height: 80vh; */
		.userinfo-box {
			padding: 20px;
			box-shadow: 0 24px 40px 0 rgba(34, 34, 34, 0.05);
			background-color: white;
			//background: rgba(0, 0, 0, 0.5);
			//margin: 20px;

			border-radius: 10px;
			// margin-bottom:20px;
		}

		.goods-box {
			margin-top: 20px;

			&:not(:last-child) {
				margin-bottom: 20px;
			}

			// background: rgba(0, 0, 0, .5);
			// margin: 20px;
			// padding: 20px;
			// border-radius: 10px;
			.goods-card-box {
				box-shadow: 0px 24px 40px 0px rgba(34, 34, 34, 0.05);
				background-color: white;
				//background: rgba(0, 0, 0, 0.5);
				padding: 20px;
				border-radius: 10px;
				position: relative;

				.renew-btn {
					position: absolute;
					right: 20px;
					top: 20px;
					color: #db4245;
				}

				.conten-box {
					.content-time-box {
						.content-time-flex {
							display: flex;
							flex-direction: column;
							margin-bottom: 15px;
							align-items: flex-start;

							span:first-child {
								margin-bottom: 5px;
							}
						}

						.youtube {
							display: flex;
							justify-content: center;
							margin: 10px 0;
						}
					}
				}
			}
		}
	}

	.footer-box {
		/* background-color: #1a1a1a; */
		background-color: #0d1821;
		/* background-color:rgb(25, 43, 55); */
		/* background-color: #001522; */
	}

	.footer-content-box {
		/* display: flex;
    justify-content: center;
    align-items: center; */
		/* background-color: #1a1a1a; */
		/* background-color:rgb(25, 43, 55); */
		/* background-color: #001522; */
	}

	.payment-box {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: center;
	}

	.payment-content-box {
		display: flex;
		flex-wrap: wrap;
		width: 100vw;
		justify-content: center;
	}

	.payment-title {
		color: hsla(0, 0%, 100%, 0.7);
		margin: 0.5rem;
		font-weight: bold;
		font-size: 14px;
		line-height: 21px;
	}

	.payment-img {
		background-size: contain;
		width: 20vw;
		height: 6vh;
		margin: 1rem;
	}

	.footer-content-gs {
		background-color: #000;
		font-weight: bolder;
		font-size: 8px;
		padding: 10px;
		color: rgb(62, 77, 83);
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	.footer-content-gs-content {
		width: 80vw;
	}

	// 详情 弹窗
	.popup-details {
		border-radius: 16px 16px 0 0;
		padding: 0.8rem;

		.details-header-box {
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.details-header-box {}
	}

	.darwer-box {
		color: #000;
		padding: 20px;
		position: relative;
	}

	.content-item {
		font-weight: 900;
	}

	.pay-button {
		color: #ffffff;
		background-color: #43d98e;
		height: 5vh;
		border-radius: 20px;
		border: 1px solid;
		width: 100%;
	}
}

/**获取链接class**/
.gtlink {
	font-size: 17px;
	font-weight: bold;
	text-decoration: underline;
	padding-top: 10px;
	padding-bottom: 10px;
	width: 50%;
}

.toytb-btn {
	cursor: pointer;
	font-size: 12px;
	font-weight: bold;
	text-decoration: underline;
	padding: 10px 10px 10px 0;
	color: #db4245;
}
.item-tips{
	margin-left: 5px;
	color: #db4245;
	font-size: large;
}
</style>